export default "__VITE_ASSET__011cfb5d__"